/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpertDocumentDto } from './ExpertDocumentDto';
import type { ExpertGalleryImageDto } from './ExpertGalleryImageDto';
import type { ExpertServiceAreaDto } from './ExpertServiceAreaDto';
import type { ExpertServiceDto } from './ExpertServiceDto';
import type { ExpertSuspensionDetailsDto } from './ExpertSuspensionDetailsDto';
export type ExpertDetailDto = {
    /**
     * Display ID in EX-XX format
     */
    id: string;
    /**
     * Expert UUID (internal)
     */
    expertId: string;
    /**
     * User UUID for admin operations (e.g. suspend, reactivate)
     */
    userId: string;
    /**
     * Expert category slug for badge and feature flags
     */
    expertType?: ExpertDetailDto.expertType;
    /**
     * Full name
     */
    name: string;
    /**
     * Email address
     */
    email: string;
    phoneCountryCode?: Record<string, any>;
    phoneNumber?: Record<string, any>;
    gender?: Record<string, any>;
    dateOfBirth?: Record<string, any>;
    shortBio?: Record<string, any>;
    yearsOfExperience?: Record<string, any>;
    educationLevel?: Record<string, any>;
    badgeLevel: string;
    profileImageUrl?: Record<string, any>;
    videoIntroUrl?: Record<string, any>;
    isAcceptingBookings: boolean;
    defaultSessionDurationMinutes: number;
    bufferTimeMinutes: number;
    maxSessionsPerDay?: Record<string, any>;
    whatsappNumber?: Record<string, any>;
    verificationStatus: string;
    verifiedAt?: Record<string, any>;
    verificationNotes?: Record<string, any>;
    isFasttrackVerification: boolean;
    averageRating: number;
    totalRatings: number;
    /**
     * Whether authenticated client can submit review (completed >= 1 session and no existing review)
     */
    canReview: boolean;
    /**
     * Whether authenticated client already submitted a review for this expert
     */
    reviewSubmitted: boolean;
    totalSessions: number;
    totalClients: number;
    activeClients: number;
    /**
     * Total revenue (formatted) for this expert from payouts
     */
    revenue?: Record<string, any>;
    /**
     * Count of active package bookings
     */
    activePackages?: number;
    /**
     * Count of disputes involving this expert
     */
    disputesCount?: number;
    accountStatus: string;
    isProfileComplete: boolean;
    /**
     * Present when account is suspended
     */
    suspensionDetails?: ExpertSuspensionDetailsDto;
    joinedAt: string;
    /**
     * Available session modes (online, client_location, expert_location)
     */
    modes: Array<string>;
    services: Array<ExpertServiceDto>;
    serviceAreas: Array<ExpertServiceAreaDto>;
    documents: Array<ExpertDocumentDto>;
    /**
     * List of gallery images for the expert
     */
    images: Array<ExpertGalleryImageDto>;
    /**
     * Expert service radius in kilometres
     */
    serviceRadiusKm?: number | null;
    /**
     * Distance from client primary location to expert in kilometres (null if client location unavailable)
     */
    distanceKm?: number | null;
    /**
     * Current active subscription plan name (null if no active subscription)
     */
    currentSubscriptionPlanName?: string | null;
    /**
     * ISO date when the current subscription expires (null if no active subscription)
     */
    currentSubscriptionValidUntil?: string | null;
};
export namespace ExpertDetailDto {
    /**
     * Expert category slug for badge and feature flags
     */
    export enum expertType {
        PERSONAL_TRAINER = 'personal_trainer',
        PHYSIOTHERAPIST = 'physiotherapist',
        PSYCHOLOGIST = 'psychologist',
        TRAINED_LISTENER = 'trained_listener',
    }
}

